"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=department.writeable.list.js.map